<template>
  <div>
    <h1>Search User Bucket Permissions</h1>

    <div class="row mb-3">
      <div class="col-sm">

          <form ref="form" @submit.prevent="fetchUserBuckets">
              <div class="d-flex align-items-center">
                  <b-form-group class="col-6 mb-0"
                                label="User Id" label-for="user-id-input">
                      <b-form-input id="user-id-input"
                                    v-model="selected.username"
                                    aria-describedby="input-1-live-feedback"
                                    required>
                      </b-form-input>
                      <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                      </b-form-invalid-feedback>
                      <b-form-text id="user-name-input-help">Required.</b-form-text>
                  </b-form-group>

                  <b-button type="submit" variant="primary" class="col-1 mt-2">Search</b-button>
              </div>
          </form>

      </div>
    </div>

    <div class="row" v-if="isSearching">
      <div class="col-sm">
        <b-table hover small responsive show-empty
          :fields="fields"
          :items="userBuckets"
          :busy="isLoading">

          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>

          <template v-slot:empty="scope">
            <p>No user permissions found.</p>
          </template>

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
            <strong>Loading, Please Wait...</strong>
          </div>        
        </b-table>
      </div>
    </div>

  </div>
</template>

<script>
  import config from '@/config'
  import axios from 'axios';
  import axiosRetry from 'axios-retry';
  import { validationMixin } from 'vuelidate'
  import { required, minLength } from 'vuelidate/lib/validators'

  axiosRetry(axios, { retries: 3 });

  export default {
    mixins: [validationMixin],
    props: [
        'id'
    ],

    data: () => ({
      isLoading: false,
      isSearching: false,

      fields: [
        {key: 'userId', sortable: true, label: 'User Id'},
        {key: 'bucketName', sortable: true, label: 'Bucket Name'},
        {key: 'upload', sortable: true, label: 'Upload'},
        {key: 'list', sortable: true, label: 'List'},
        {key: 'download', sortable: true, label: 'Download'},
        {key: 'delete', sortable: true, label: 'Delete'},
        {key: 'tag', sortable: true, label: 'Tag'},
        {key: 'viewTag', sortable: true, label: 'View Tags'},
        {key: 'isBucketAdmin', sortable: true, label: 'Bucket Admin'},
      ],
      userBuckets: [],
      editedIndex: -1,
      selected: {
          username: "",
          list: null,
          upload: null,
          download: null,
          delete: null,
          tag: null,
          viewTag: null,
          buckets: []
      },

      tfOptions: [
          { text: 'True', value: true },
          { text: 'False', value: false },
      ]
    }),

    created () {
      this.initialize()
    },

    computed: {
      formTitle () {
        return 'User Bucket Permissions'
      }
    },



    methods: {
      fetchUserBuckets() {
        var url = `${config.CLOUDDRIVE_API_ENDPOINT}userbuckets/${this.selected.username}`
          axios.get(url)
            .then(response => {
                this.userBuckets = response.data
                this.isLoading = false
                this.isSearching = true
            })
      },

      initialize() {
          this.isLoading = true
      },

    }
  }
</script>